import CSS from 'csstype';
const FullLoaderComponent = ({ msg }) => {
    return (
        <div style={styleContainer}>
            <div className='text-center'>
                <span>{msg}</span>
                <div className="flex items-center justify-center space-x-2 animate-bounce mt-2">
                    <div className="w-8 h-8 bg-emerald-200 rounded-full"></div>
                    <div className="w-8 h-8 bg-emerald-200 rounded-full"></div>
                    <div className="w-8 h-8 bg-emerald-200 rounded-full"></div>
                </div>
            </div>
        </div>
    );
};


const styleContainer: CSS.Properties = {
    width: '100%',
    height: '100%',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    position: 'fixed'
}

export default FullLoaderComponent;
